import axiosInstance from "../axios/axios_instance"
const http = axiosInstance("/protected",  null, "/feedback")


const getFeedbackReviews = (teamId) => http.get(`/feedback_reviews/${teamId}`);

export default {
    getFeedbackReviews
}